import React, { useEffect, useState } from 'react';
import './Plats.css';

import image1 from '../../../images/Plats/pic1.jpg';
import image2 from '../../../images/Plats/pic2.png';
import image3 from '../../../images/Plats/pic3.png';
import star from '../../../images/star.svg';

import Carousel from 'react-bootstrap/Carousel';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	sectionDesktop: {
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			justifyContent: 'center'
		}
	},
	sectionMobile: {
		display: 'flex',
		justifyContent: 'center',
		[theme.breakpoints.up('md')]: {
			display: 'none'
		}
	}
}));

const data = [
	{
		id: 1,
		titre: 'Cuisson au feu de bois',
		text: 'Découvrez nos délicieuses pizzas napolitaines cuites au four à bois :)',
		prix: 'Engagement 1',
		photo: image1
	},
	{
		id: 2,
		titre: 'Qualité & Fraîcheur',
		text: 'Toutes nos pizzas sont élaborées à partir de produits frais & de qualité !',
		prix: 'Engagement 2',
		photo: image2
	},
	{
		id: 3,
		titre: 'Maintien au chaud',
		text: 'Nos pizzas sont maintenues à température durant la livraison.',
		prix: 'Engagement 3',
		photo: image3
	}
];

const Plats = () => {
	const classes = useStyles();
	const [ windowWidth, setWindowWidth ] = useState(window.innerWidth);

	const handleResize = (e) => {
		setWindowWidth(window.innerWidth);
	};

	useEffect(() => {
		window.addEventListener('resize', handleResize);
	}, []);

	return (
		<div className="plats" id="plats">
			<div className="platsTitleContainer">
				<Typography gutterBottom variant="h5" component="h1" className="platsTitle">
					Nos Atouts
				</Typography>
			</div>

			{windowWidth >= 960 ? (
				
					<div className="plats-card">
						{data.map((content) => (
							<Card className="cardItem">
								<img src={content.photo} alt="Contemplative Reptile" />

								<CardContent>
									<Typography gutterBottom variant="h5" component="h2" className="cardTitle">
										{content.titre}
									</Typography>
									<Typography
										variant="body2"
										color="textSecondary"
										component="p"
										className="cardText"
									>
										{content.text}
									</Typography>
									<Typography variant="body2" color="textDanger" component="p" className="cardPrice">
										{content.prix}
									</Typography>
								</CardContent>
							</Card>
						))}
					</div>
			) : (
				<Carousel pause={false} className="slider-card">
					{data.map((content) => (
						<Carousel.Item interval={5000} className="px-3" key={content.titre}>
							<Card className="cardItem">
								<img src={content.photo} alt="Contemplative Reptile" />
								<CardContent>
									<Typography gutterBottom variant="h5" component="h2" className="cardTitle">
										{content.titre}
									</Typography>
									<Typography
										variant="body2"
										color="textSecondary"
										component="p"
										className="cardText"
									>
										{content.text}
									</Typography>
									<Typography variant="body2" color="textDanger" component="p" className="cardPrice">
										{content.prix}
									</Typography>
								</CardContent>
							</Card>
						</Carousel.Item>
					))}
				</Carousel>
			)}

			<div className="command_button">
				<Link to="/carte" className="telecharger_btn values__button">
					Découvrir la carte !
				</Link>
			</div>
		</div>
	);
};

export default Plats;
